import React from "react";
import { Link, useLocation } from "react-router-dom";

function NavbarGA() {

    const location = useLocation();

    return (
        <nav className="flex flex-row justify-around">
            <Link to="/mesga/main" className={`${location.pathname === '/mesga/main' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-400`}>
                Main
            </Link>
            <Link to="/mesga/kaga" className={`${location.pathname === '/mesga/kaga' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-200`}>
                KaGA
            </Link>
        </nav>
    );
}

export default NavbarGA